import jwt from 'jsonwebtoken';
import { v4 } from 'uuid';
import { getStorage } from '../general';

const parseJson = async response => {
  const text = await response.text();
  try {
    const json = JSON.parse(text);
    if (!json) {
      return { status: response.status, response: null };
    }
    return json;
  } catch (err) {
    return { status: response.status, response: text };
  }
};

async function bcApi(endpoint, method = 'GET', body = null, version = null, overrideCartId = null) {
  const options = {
    method: method,
    credentials: 'same-origin',
    mode: 'same-origin'
  };

  if (body) {
    let bodyString = body;
    if (typeof body === 'object') {
      bodyString = JSON.stringify(body);
    }

    options.body = bodyString;
  }

  const encodedEndpoint = Buffer.from(endpoint).toString('base64');
  const userToken = getStorage('_loggedIn');

  if (userToken) {
    options.headers = {
      'Content-Type': 'application/json',
      'BC-Auth-Token': userToken
    };
  }

  if (!(typeof fetch === 'undefined')) {
    const response = await fetch(
      `/api/bigcommerce?${version ? `v=${version}&` : ''}${
        overrideCartId ? `overrideCartId=${overrideCartId}&` : ''
      }endpoint=${encodedEndpoint}`,
      options
    );

    const jsonResponse = await parseJson(response);
    return {
      response: jsonResponse,
      status: jsonResponse.status || response.status
    };
  } else {
    return { response: null, status: 404 };
  }
}

async function bcLoginUrl(customerId, redirectTo) {
  const bcTime = await bcApi('time', 'GET', null, 2);
  const dateCreated =
    bcTime.status === 200 && 'time' in bcTime.response
      ? bcTime.response.time
      : Math.round(new Date().getTime() / 1000);
  const payload = {
    iss: process.env.GATSBY_BC_CLIENT_ID,
    iat: dateCreated,
    jti: v4(),
    operation: 'customer_login',
    store_hash: process.env.GATSBY_BC_HASH,
    customer_id: customerId,
    redirect_to: redirectTo
  };
  let token = jwt.sign(payload, process.env.GATSBY_BC_CLIENT_SECRET, {
    algorithm: 'HS256'
  });
  return `${process.env.GATSBY_BC_PATH}/login/token/${token}`;
}

function transformBCPost(post) {
  const API_STORE_HASH = process.env.GATSBY_BC_HASH;
  const thumbnail_uri = post.thumbnail_path
    ? `https://cdn11.bigcommerce.com/s-${API_STORE_HASH}${post.thumbnail_path}`
    : '';
  const post_url = post.url.replace(/\/bc-blog\//g, '');

  return {
    id: post.id,
    title: post.title,
    excerpt: post.summary,
    slug: `/bc-blog${post_url}`,
    content: post.body,
    author_name: post.author,
    author_uri: post.author, // TODO: need to find author uri
    published_date: post.published_date.date,
    thumbnail_path: thumbnail_uri,
    tags: post.tags.map(t => ({ name: t, uri: '' })),
    comments: []
    // categories: post.categories.nodes,
  };
}

export { bcApi, bcLoginUrl, transformBCPost };
